
// ======================================================================
// FILE:
// src/modules/finance/transactions/receivables/services/receivablesService.js
//
// MODULE: Finance - Accounts Receivable
// ======================================================================

import axiosClient from "../../../../../api/axiosClient";

const BASE_URL = "/api/finance/receivables";

const unwrap = (response) =>
    response?.data?.data ?? response?.data ?? {};

// ----------------------------------------------------------------------
// LIST OUTSTANDING RECEIVABLES
// ----------------------------------------------------------------------

async function listReceivables(params = {}) {
    const response = await axiosClient.get(
        BASE_URL,
        { params }
    );

    const data = unwrap(response);

    if (Array.isArray(data)) {
        return data;
    }

    return (
        data?.rows ||
        data?.items ||
        data?.data ||
        []
    );
}

// ----------------------------------------------------------------------
// GET RECEIVABLE / INVOICE DETAILS
// ----------------------------------------------------------------------

async function getReceivable(invoiceId) {
    const response = await axiosClient.get(
        `${BASE_URL}/${invoiceId}`
    );

    return unwrap(response);
}

// ----------------------------------------------------------------------
// VALIDATE RECEIPT AMOUNT
// ----------------------------------------------------------------------

async function validateReceipt(invoiceId, payload) {
    const response = await axiosClient.post(
        `${BASE_URL}/${invoiceId}/validate-receipt`,
        payload
    );

    return unwrap(response);
}

// ----------------------------------------------------------------------
// CREATE DRAFT RECEIPT VOUCHER
// ----------------------------------------------------------------------

async function createReceiptForInvoice(invoiceId, payload) {
    const response = await axiosClient.post(
        `${BASE_URL}/${invoiceId}/receipts`,
        payload
    );

    return unwrap(response);
}

// ----------------------------------------------------------------------
// EXPORTS
// ----------------------------------------------------------------------

export {
    listReceivables,
    getReceivable,
    validateReceipt,
    createReceiptForInvoice,
};
